var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Dashboard',{staticClass:"test wrapper"},[_c('div',{staticClass:"speed"},[_c('span',{staticClass:"value"},[_vm._v(_vm._s(_vm.telemetry2.truck.speed.toFixed(0)))]),_c('small',{staticClass:"unit"},[_vm._v(_vm._s(_vm.$unitReadable('unit_speed')))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }